import { render, staticRenderFns } from "./PaginatedTable.vue?vue&type=template&id=35171f2b&scoped=true"
import script from "./PaginatedTable.vue?vue&type=script&lang=ts"
export * from "./PaginatedTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35171f2b",
  null
  
)

export default component.exports